import { SET_MENU_ITMES, SET_HOME_DATA, SHOW_LOADER, HIDE_LOADER, SET_WEB_LANGUAGE, SET_TTS_STATUS, SET_ALL_LANGUAGES_LIST, SET_CAPTCHA_IMAGE } from "../../common/constants/ActionTypes";

const initialState = {
    errorMessage: "",
    captchaId: 0,
    loading: false,
    allMenuItems: [],
    homePageData: [],
    webLanguage: "",
    isTtsActive: false,
    allLanguagesList: [],
}

export default function commonReducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_LOADER:
            return {
                ...state,
                loading: true
            }
        case HIDE_LOADER:
            return {
                ...state,
                loading: false
            }
        case SET_MENU_ITMES:
            return {
                ...state,
                allMenuItems: action.payload
            }
        case SET_HOME_DATA:
            return {
                ...state,
                homePageData: action.payload
            }
        case SET_WEB_LANGUAGE:
            return {
                ...state,
                webLanguage: action.payload
            }
        case SET_TTS_STATUS:
            return {
                ...state,
                isTtsActive: action.payload
            }
        case SET_ALL_LANGUAGES_LIST:
            return {
                ...state,
                allLanguagesList: action.payload
            }

        case SET_CAPTCHA_IMAGE:
  return {
    ...state,
    captchaId: action.payload
  };


        default:
            return state;
    }
}